import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { updateEmail } from 'firebase/auth';
import { auth, db } from '../firebase';
import { doc, updateDoc, getDoc } from 'firebase/firestore';

const EmailChangeModal = ({ isOpen, onClose, onSuccess, currentEmail }) => {
  const [newEmail, setNewEmail] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);

    try {
      const uid = auth.currentUser.uid;
      
      // First update the auth email
      await updateEmail(auth.currentUser, newEmail);

      // Update the user document in Firestore, preserving original email
      const userDocRef = doc(db, 'users', uid);
      const userDoc = await getDoc(userDocRef);
      
      // If this is the first email change, store the current email as original
      if (userDoc.exists() && !userDoc.data().originalEmail) {
        await updateDoc(userDocRef, {
          email: newEmail,
          originalEmail: currentEmail,
          displayEmail: currentEmail
        });
      } else {
        // If already changed before, just update the email
        await updateDoc(userDocRef, {
          email: newEmail
        });
      }

      onSuccess(newEmail);
      onClose();
    } catch (error) {
      console.error("Error updating email: ", error);
      setError("Your login token is likely too old. Please logout and log back in");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Change Account Email</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Current Email
            </label>
            <input
              type="email"
              value={currentEmail}
              disabled
              className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              New Email
            </label>
            <input
              type="email"
              value={newEmail}
              onChange={(e) => setNewEmail(e.target.value)}
              required
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
            />
          </div>
          {error && (
            <div className="text-red-500 text-sm">{error}</div>
          )}
          <div className="flex justify-end space-x-2 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isSubmitting}
              className="px-4 py-2 text-sm font-medium text-white bg-blue-500 rounded-md hover:bg-blue-600 disabled:opacity-50"
            >
              {isSubmitting ? 'Updating...' : 'Update Email'}
            </button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default EmailChangeModal;